import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { queryAuditoria, resolveUserIds, type AuditoriaQueryParams } from '../api/auditoria';
import { queryKeys } from '@/lib/pwa/queryConfig';

export function useAuditoriaQuery(
  params: AuditoriaQueryParams,
  enabled = true,
  refetchInterval: number | false = false,
) {
  return useQuery({
    queryKey: [...queryKeys.admin.auditoria, params],
    queryFn: () => queryAuditoria(params),
    enabled,
    refetchInterval,
  });
}

/** Resolve actor_id UUIDs para nomes de usuários. */
export function useActorNames(actorIds: (string | null)[]) {
  const uniqueIds = useMemo(
    () => [...new Set(actorIds.filter((id): id is string => !!id))].sort(),
    [actorIds],
  );
  return useQuery({
    queryKey: [...queryKeys.admin.userNames, 'ids', uniqueIds.join(',')],
    queryFn: () => resolveUserIds(uniqueIds),
    enabled: uniqueIds.length > 0,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });
}
